import { Router } from '@angular/router';
import { Action } from './transaction-helper-action.interface';

export class UploadPaymentReceipts implements Action<void> {
    public constructor(private router: Router) {}

    public execute(): void {
        const newUrl: string = this.router.url.replace(/[^/]+$/, 'screenshot');
        this.router.navigate([newUrl]);
    }
}
